// components
import { Image } from "components/kit/Image";
import { Box } from "@mui/material";
// config
import { LOGO } from "../../../config";
// hooks
import { SxProps, useTheme } from "@mui/material/styles";
import { useCollapseDrawer } from "hooks/useProvidersHooks";
import { FC } from "react";

export const Logo: FC<{ sx?: SxProps }> = (props) => {
  const { sx } = props;
  const theme = useTheme();
  const { isCollapse } = useCollapseDrawer();
  return (
    <Box sx={{ flex: 1, px: theme.spacing(2, 3) }}>
      <Image
        src={"/arshco.png"}
        alt={"Logo"}
        sx={{
          width: isCollapse
            ? LOGO.NAVBAR_LOGO_COLLAPSED.width
            : LOGO.NAVBAR_LOGO.width,
          height: isCollapse
            ? LOGO.NAVBAR_LOGO_COLLAPSED.height
            : LOGO.NAVBAR_LOGO.height,
          ...sx,
        }}
      />
    </Box>
  );
};
